"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const i18next_1 = __importDefault(require("i18next"));
const functions_1 = require("@/common/functions");
function default_1({ channelId, channelName, confirm, onBlockChanged, }) {
    return __awaiter(this, void 0, void 0, function* () {
        yield confirm({
            description: ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [i18next_1.default.t('내가 차단한 사용자예요.'), (0, jsx_runtime_1.jsx)("br", {}), i18next_1.default.t('차단 해제하고 폼을 둘러보시겠어요?')] })),
            confirmationText: i18next_1.default.t('차단해제'),
            allowClose: false,
        })
            .then(() => __awaiter(this, void 0, void 0, function* () {
            yield (0, functions_1.changeBlockState)({
                channelId,
                onBlockChanged,
                channelName,
            });
        }))
            .catch(functions_1.goToMain);
    });
}
exports.default = default_1;
